import { render, staticRenderFns } from "./StorageMaker.vue?vue&type=template&id=2a24b31c&scoped=true"
import script from "./StorageMaker.vue?vue&type=script&lang=js"
export * from "./StorageMaker.vue?vue&type=script&lang=js"
import style0 from "./StorageMaker.vue?vue&type=style&index=0&id=2a24b31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a24b31c",
  null
  
)

export default component.exports